/**
 * Страница открыта сборщиком статических копий (scripts/prerender.js), а не
 * посетителем.  В этом режиме не показываем баннер cookie и не регистрируем
 * service worker — иначе они попали бы в готовый HTML или сорвали снимок.
 */
export const isPrerender = (): boolean =>
    typeof window !== 'undefined' &&
    !!(window as Window & { __RC_PRERENDER__?: boolean }).__RC_PRERENDER__
